export default "__VITE_ASSET__BjwpzuOo__"